/*
 * @fileOverView Search component definition
 */

import Vue from 'vue';
import Search from 'components/modules/utility/search/search.mixin';
import { mapGetters } from 'vuex'

/**
 * [Search Vue]
 * @type {class}
 */
Vue.component('search-vue', {
  mixins: [Search],

  computed: {
    ...mapGetters(['suggestions/filter']),
    filterSearch() {
      if (!this.$store.state["suggestions"].loaded) {
        this.$store.dispatch('suggestions/fetch');
      }
      return this['suggestions/filter'](this.search).map(item => {
        return {
          "term": item,
          "url": '/search?query=' + item
        }
      });
    }
  },

  mounted() {
    const input = this.$el.querySelector('.search-input');

    this.$parent.$on('nav-expanded', (isExpanded) => {
      if (isExpanded) {
        setTimeout(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus();
          }
        }, 305);
      }
    });

    if (input && input.defaultValue) {
      this.search = input.defaultValue;
    }
  },

  methods: {

    /**
     * Handles submission of search form on selection of a term.
     *
     * @method handleSubmit
     * @public
     */
    handleSubmit() {
      if (this.$refs.form) {
        this.$refs.form.submit();
      }
    }
  }
});
